module.exports = __webpack_public_path__ + "img/gallery.65bac198.png";